import { render, staticRenderFns } from "./HistoryEvent.vue?vue&type=template&id=2af16c74&"
import script from "./HistoryEvent.vue?vue&type=script&lang=js&"
export * from "./HistoryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports